(ns portal.user-account-page.view.personal-information
  (:require ["@mui/material/Button$default" :as Button]
            ["@mui/material/Dialog$default" :as Dialog]
            ["@mui/material/DialogContent$default" :as DialogContent]
            ["@mui/material/DialogTitle$default" :as DialogTitle]
            ["@mui/material/Stack$default" :as Stack]
            [common.url-template :as url-tpl]
            [common.widgets.checkbox :refer [checkbox]]
            [common.widgets.form-field :refer [form-field]]
            [common.widgets.input :refer [input]]
            [common.widgets.panel :refer [panel]]
            [portal.user-account-page.db.personal-information :as form]
            [re-frame.core :as rf]
            [uix.core :refer [$ defui]]
            [uix.re-frame :refer [use-subscribe]]))

(rf/reg-event-db ::close-modal
  (fn [db] (assoc db ::modal-closed true)))

(rf/reg-sub ::modal-closed?
  (fn [db] (get db ::modal-closed)))

(defui no-role-modal [{:keys [role-not-defined]}]
  (let [url-context (use-subscribe [:url-context])
        support-request-url (url-tpl/render :docs/support url-context)]
    ($ Dialog
       {:open role-not-defined
        :onClose #(rf/dispatch [::close-modal])
        :fullWidth true
        :maxWidth "xs"}
       ($ DialogTitle {:variant "h2"}
          "No agency / advertiser assigned")
       ($ DialogContent
          "Your account is not assigned to an Agency / Advertiser. To continue, contact Creative Optimizations support
         with your required Agency / Advertiser configuration via the the support portal: "
          ($ :a {:href support-request-url} support-request-url)))))

(defui controls []
  (let [mode (use-subscribe [:form.personal-information/mode])
        errors? (use-subscribe [:form.personal-information/errors?])]
    (if (= mode :read)
      ($ Button
         {:variant "contained"
          :onClick #(rf/dispatch [:form.personal-information/change-mode :edit])
          :data-testid "edit-account-button"}
         "Edit my account")
      ($ :<>
         ($ Button
            {:variant "text"
             :onClick #(rf/dispatch [:form.personal-information/cancel-edit])
             :data-testid "cancel-button"}
            "Cancel")
         ($ Button
            {:variant "contained"
             :disabled errors?
             :type "submit"
             :data-testid "save-button"}
            "Save")))))

(defui privacy-field [{:keys [accepted?]}]
  (let [unspecified-preference "You did not tell us yet if we can use your personal data in order to
                               optimize our platform. We do not use your personal data at this moment."
        specified-preference " allow Creative Optimizations (Hereby Data Controller) to handle
                               and process my personal data (user-id and ip-address) for the purpose of
                               optimising the Creative Optimizations platform. Your data is used and/or processed by
                               Google Analytics for a maximum period of two years."]
    (case accepted?
      "" ($ :p unspecified-preference)
      true ($ :p "I " ($ :b "do") specified-preference)
      false ($ :p "I " ($ :b "do not") specified-preference))))

(defui personal-information-form [{:keys [sso]}]
  (let [mode (use-subscribe [:form.personal-information/mode])
        {has-role :role, has-email :email, okta-id :oktaId, sso-email :ssoEmail} (use-subscribe [:resource.user/me])
        {:keys [name email role privacySettingsAccepted]} (use-subscribe [:form.personal-information/value []])
        modal-closed? (use-subscribe [::modal-closed?])
        role-not-defined (when has-email (not (or has-role modal-closed?)))

        name-control (form/use-bind-control [:name])
        email-control (form/use-bind-control [:email])
        privacy-control (form/use-bind-control [:privacySettingsAccepted])]
    ($ :form {:onSubmit (fn [e]
                          (.preventDefault e)
                          (rf/dispatch [:form.personal-information/submit sso]))}
       ($ panel {:title "Personal information"
                 :actions ($ controls)}
          ($ no-role-modal {:role-not-defined role-not-defined})
          ($ Stack
             {:spacing 2
              :sx #js {:width "38rem"}}
             ($ form-field
                {:label "Name"
                 :err-msg (form/use-error-message [:name])
                 :data-testid :name-field}
                (if (= mode :read)
                  name
                  ($ input name-control)))


             ($ form-field
                {:label "Account Email"
                 :err-msg (form/use-error-message [:email])
                 :data-testid :email-address-field}
                (if (or sso (= mode :read))
                  email
                  ($ input
                     (merge email-control {:type "email"}))))

             (when sso-email
               ($ form-field
                  {:label "SSO Email"
                   :data-testid :sso-email-field}
                  sso-email))

             ($ form-field
                {:label "Okta ID"
                 :data-testid :okta-id-field}
                (or okta-id "Not set"))

             ($ form-field
                {:label "Role"
                 :data-testid :role-field}
                (:name role))

             ($ form-field
                {:label "Privacy settings"
                 :data-testid :privacy-settings-field}
                (if (= mode :read)
                  (when (some? privacySettingsAccepted)
                    ($ privacy-field {:accepted? privacySettingsAccepted}))
                  ($ checkbox
                     (merge privacy-control
                            {:label "I allow Creative Optimizations (Hereby Data Controller) to handle and
                       process my personal data (user-id and ip-address) for the
                       purpose of optimising the Creative Optimizations platform. Your data is
                       used and/or processed by Google Analytics."
                             :id :privacySettingsAccepted
                             :sx #js {:alignSelf "flex-start"}})))))))))
